export { b as AUTH_STORAGE_KEYS, y as AnalyticsManager, Q as ApiKeyApi, x as ApiKeyManager, l as AuthApi, r as AuthManager, o as AuthService, A as AuthStatus, a as AuthTokenManager, Y as BookingApi, K as BookingManager, Z as BookingService, B as BusinessManager, C as CampaignManager, J as CustomFieldDefinitionManager, h as DEFAULT_PERS_CONFIG, d as DPOP_STORAGE_KEYS, p as DPoPManager, D as DefaultAuthProvider, z as DonationManager, F as FATAL_AUTH_CODES, N as FileApi, w as FileManager, O as FileService, I as IndexedDBTokenStorage, L as LocalStorageTokenStorage, M as MemoryTokenStorage, g as PersApiClient, q as PersEventEmitter, _ as PersEventsClient, P as PersSDK, v as PurchaseManager, R as RedemptionManager, S as SDK_NAME, f as SDK_USER_AGENT, e as SDK_VERSION, k as StaticJwtAuthProvider, t as TokenManager, T as TrackingManager, u as TransactionManager, E as TriggerSourceManager, U as UserManager, s as UserStatusManager, H as WalletEventsManager, W as WebDPoPCryptoProvider, V as WebhookApi, G as WebhookManager, X as WebhookService, i as buildApiRoot, j as buildWalletEventsWsUrl, $ as createPersEventsClient, c as createPersSDK, n as isFatalAuthErrorInMessage, m as mergeWithDefaults } from './chunks/pers-sdk-BEF_pjl0.js';
import { buildImageCdnUrl } from '@explorins/pers-shared';
export * from '@explorins/pers-shared';
export { AccountOwnerType, DATA_SOURCE_CHANNELS, DEFAULT_DATA_SOURCE, IMAGE_CDN_DEFAULT_FIT, IMAGE_CDN_DEFAULT_FORMAT, IMAGE_CDN_DEFAULT_QUALITY, IMAGE_CDN_MAX_DIMENSION, IMAGE_CDN_PRESETS, KNOWN_SOURCE_DOMAINS, SortOrder, TaggableEntityType, VALID_USER_RELATIONS, buildImageCdnUrl, detectSourceFromReferrer, getPresetDimensions, isBookingStatusValid, isConnectedMessage, isDataSourceChannel, isErrorMessage, isEventMessage, isServerMessage, isSubscribedMessage, isSupportedImageFormat, isValidPreset, isValidUserRelation, parseUtmParams } from '@explorins/pers-shared';
export { detectEnvironment, detectWebPlatform, environment, warnIfProblematicEnvironment } from './core.js';
export { c as ApiErrorDetector, A as AuthenticationError, a as CacheService, C as CacheTTL, E as ErrorUtils, L as LogoutRequired, N as NetworkError, b as PersApiError, P as ProviderTokenRefreshNeeded, S as SdkErrorCodes, T as TokenRefreshNeeded, g as globalCacheService } from './chunks/index--OssIds0.js';
export { T as TenantManager } from './chunks/tenant-manager-xmYKBFGu.js';
export { b as buildPaginationParams, e as extractData, a as extractPagination, f as fetchAllPages, i as isPaginatedResponse, n as normalizeToPaginated } from './chunks/pagination-utils-9vQ-Npkr.js';
export { B as BusinessApi, a as BusinessMembershipApi, c as BusinessMembershipService, b as BusinessService } from './chunks/business-membership-service-C2CouLTR.js';
export { C as ClientTransactionType, T as TransactionApi, a as TransactionService, c as buildBurnRequest, b as buildMintRequest, f as buildPOSBurnRequest, e as buildPOSTransferRequest, i as buildPendingTransactionData, g as buildSubmissionRequest, d as buildTransferRequest, h as extractDeadlineFromSigningData, k as getSigningUrl, n as needsExternalSigning, j as needsSubmission } from './chunks/transaction-request.builder-D6VLhaMi.js';
export { A as AnalyticsApi, a as AnalyticsService } from './chunks/analytics-service-CF7hSwhy.js';
export { CampaignApi, CampaignService } from './campaign.js';
export { DonationApi, DonationService } from './donation.js';
export { P as PaymentApi, a as PaymentService } from './chunks/payment-service-IvM6rryM.js';
export { R as RedemptionApi, a as RedemptionService } from './chunks/redemption-service-CQ73aUTe.js';
export { T as TenantApi, a as TenantService } from './chunks/tenant-service-DlhdZAs9.js';
export { B as BaseTokenService, T as TokenSDK, g as getMetadataFromTokenUnitResponse } from './chunks/base-token-service-BysVghNg.js';
export { T as TokenApi, a as TokenService } from './chunks/token-service-Ba9fp95X.js';
export { UserApi, UserService } from './user.js';
export { UserStatusApi, UserStatusService, createUserStatusSDK } from './user-status.js';
export { TriggerSourceApi, TriggerSourceService } from './trigger-source.js';
export { AngularHttpClientAdapter, BrowserFetchClientAdapter } from './platform-adapters.js';
export { N as NodeHttpClientAdapter } from './chunks/node-http-client-DloDLfm9.js';

/**
 * Build optimized image URL with automatic IPFS resolution and CDN options
 *
 * Single entry point for all image URL building:
 * - IPFS URIs → resolved via gateway + CDN options applied
 * - HTTP URLs → CDN options applied directly
 *
 * @param url - Image URL (ipfs://, https://, or any URL)
 * @param options - CDN optimization options (preset, quality, format, fit)
 * @param gateway - IPFS gateway domain (required for ipfs:// URLs)
 * @returns Optimized URL with query parameters
 *
 * @example
 * ```typescript
 * // IPFS thumbnail
 * buildImageUrl('ipfs://QmHash', { preset: 'thumb' }, 'cdn.example.com')
 * // => 'https://cdn.example.com/ipfs/QmHash?preset=thumb'
 *
 * // IPFS hero with high quality
 * buildImageUrl('ipfs://QmHash', { preset: 'hero', q: 95, fit: 'cover' }, 'cdn.example.com')
 * // => 'https://cdn.example.com/ipfs/QmHash?preset=hero&q=95&fit=cover'
 *
 * // HTTP URL (gateway ignored)
 * buildImageUrl('https://example.com/photo.jpg', { preset: 'card' })
 * // => 'https://example.com/photo.jpg?preset=card'
 *
 * // No options - just IPFS resolution
 * buildImageUrl('ipfs://QmHash', undefined, 'cdn.example.com')
 * // => 'https://cdn.example.com/ipfs/QmHash'
 * ```
 */
function buildImageUrl(url, options, gateway) {
    if (!url)
        return '';
    let resolvedUrl = url;
    // Resolve IPFS to HTTP via gateway
    if (url.startsWith('ipfs://')) {
        if (!gateway) {
            console.warn('[buildImageUrl] IPFS URL requires gateway parameter');
            return url;
        }
        const cid = url.replace('ipfs://', '');
        resolvedUrl = `https://${gateway}/ipfs/${cid}`;
    }
    // Apply CDN options
    return buildImageCdnUrl(resolvedUrl, options);
}
/**
 * Check if a URL is an IPFS URI
 *
 * @param url - URL to check
 * @returns True if URL starts with ipfs://
 */
function isIpfsUrl(url) {
    return !!url && url.startsWith('ipfs://');
}
/**
 * Extract CID from IPFS URI
 *
 * @param ipfsUri - IPFS URI (ipfs://Qm... or ipfs://baf...)
 * @returns CID string, or null if not a valid IPFS URI
 *
 * @example
 * ```typescript
 * extractIpfsCid('ipfs://QmHash123')
 * // => 'QmHash123'
 *
 * extractIpfsCid('https://example.com/image.jpg')
 * // => null
 * ```
 */
function extractIpfsCid(ipfsUri) {
    if (!isIpfsUrl(ipfsUri))
        return null;
    return ipfsUri.replace('ipfs://', '');
}

export { buildImageUrl, extractIpfsCid, isIpfsUrl };
//# sourceMappingURL=index.js.map
